/*
 *
 * NewsHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Mar-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import NewsHomePopups from './NewsHomePopups'
import { nullSafe } from 'Utility/globalMethods'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'
import * as DeepLinkingActions from 'Store/actions/deepLinking'
import componentConfig from '../../modules/componentConfig'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch),
  ...bindActionCreators(DeepLinkingActions, dispatch)

})

const mapStateToProps = (state) => ({
  newsInfo: nullSafe(() => state.triggerTimeline.current.additionalInfo, ''),
  isLoading: nullSafe(() => state.loading.localLoading.get_comunication_detail, false),
  isTerminalActivationVisible: componentConfig.newsHomePopups.terminalActivation.isVisible(),
  userRole: nullSafe(() => state.userProfiling.profiling.user.userRole, ''),
  hasActivableTerminals: nullSafe(() => state.userProfiling.profiling.hasActivableTerminals, false),
  qrActivableTerminals: nullSafe(() => state.userProfiling.profiling.qrActivableTerminals, 0)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(NewsHomePopups)
